import { Children } from "react";

import { Text } from "../text/Text";

import "./MetaDataList.css";

import type { ReactElement, ReactNode } from "react";

export interface MetaDataListProps {
  children?: ReactElement<typeof MetaDataListItem>[];
}

export interface MetaDataListItemProps {
  children?: string;
}

export function MetaDataList({ children }: MetaDataListProps) {
  return (
    <div className="MetaDataList">
      {Children.map<ReactNode, MetaDataListProps["children"]>(
        children,
        (child) => child,
      )?.reduce((prev, curr, i) => [
        prev,
        <Text preset="meta" key={i}>
          {"•"}
        </Text>,
        curr,
      ])}
    </div>
  );
}

export function MetaDataListItem({ children }: MetaDataListItemProps) {
  return <Text preset="pretitle">{children}</Text>;
}

MetaDataList.Item = MetaDataListItem;
